<template>
    <div
        class="AdminLayout"
        :class="{collapsed : navbarCollapse}"
    >
        <AdminHeader
            v-if="header"
            v-bind="header"
            :logo="logo"
            :label="title"
            @onSignout="handleSignout"
        />

        <fragment v-if="false">
            <AdminNavbar
                :navbar="navbar"
                :logo="logo"
                :collapsed="navbarCollapse"
                :label="title"
                @toggleCollapse="toggleCollapse"
                @onSignout="handleSignout"
            />
        </fragment>

        <div class="AdminContainer">
            <div class="AdminContent flex-1">
                <Transition
                    name="main-router"
                    mode="out-in"
                    @beforeEnter="enableHidden"
                    @beforeLeave="enableHidden"
                    @afterLeave="disableHidden"
                    @afterEnter="disableHidden"
                >
                    <RouterView
                        :key="entityId"
                        :entity="entityId"
                        v-bind="entity"
                        @error="handlerError"
                    />
                </Transition>
            </div>
        </div>
    </div>
</template>
<script>
import Config from '@/config/admin'
import { AdminHeader, AdminNavbar } from '@/components'
import { mediaQueryMixin } from '@/mixins'
import { notification } from '@/utils/errors'

export default {
    name: 'AdminLayout',
    components: {
        AdminHeader,
        AdminNavbar,
    },
    mixins: [mediaQueryMixin],
    data () {
        return {
            isHidden: false,
            navbarCollapse: false,
            ...Config,
        }
    },
    computed: {
        header () {
            return typeof this.head === 'boolean' && this.head ? {} : this.head
        },
        entityId () {
            return (this.$route.params || {}).entity || (this.$route.params || {}).entityKey
        },
        entity () {
            const { entity } = this.$route.params || {}
            const { method } = this.$route.meta || {}

            if (!this.entities || !entity || !method) return undefined
            return (this.entities[entity] || {})[method]
        },
    },
    watch: {
        mq: {
            handler ({ w }) {
                if (w <= this.mq.md.max && !this.navbarCollapse) {
                    this.navbarCollapse = true
                }
                if (w >= this.mq.md.max && this.navbarCollapse) {
                    this.navbarCollapse = false
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        handlerError (error) {
            if (error) this.$notify(notification({ ...error, duration: 3000, group: 'global' }))
        },
        handleSignout () {
            this.$router.push({ name: Config.head.signout })
        },
        enableHidden () {
            this.isHidden = true
        },
        disableHidden () {
            this.isHidden = false
        },
        toggleCollapse () {
            this.navbarCollapse = !this.navbarCollapse
        },
    },
}
</script>
<style scoped lang="scss">
$navbar-width: 200px;

.Admin {
    &Layout {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 100vh;
    }

    &Header {
        position: fixed;
        background-color: $navbar-bg;
    }

    &Content {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;
        padding: $section-padding;
    }

    &Navbar {
        transition: width .3s ease-out;
        display: none;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;

        @media screen and (min-width: $md) {
            display: block;
            width: $navbar-width;

            .collapsed & {
                width: $menu-bar-width;
            }
        }

        & ~ .AdminContainer {
            @media screen and (min-width: $md) {
                margin-left: $navbar-width;

                .collapsed &{
                    margin-left: $menu-bar-width;
                }
            }
        }
    }

    &Container {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-top: $navbar-height;
        transition: margin .3s ease-out;
    }
}
</style>
